$(document).ready(function () {
  "use strict";
  // navbar js start ---
  $(window).on("load scroll", function () {
    var scrolling = $(this).scrollTop();
    if (scrolling > 10) {
      $(".navbar").addClass("nav-fixed");
    } else {
      $(".navbar").removeClass("nav-fixed");
    }
  });

  $(".ham-menu").click(function (event) {
    event.stopPropagation();
    $(".navbar-btm").toggleClass("active");
    $(".ham-menu").toggleClass("active");
    $(".navbar-btm .container").toggleClass("active");
    $("body").toggleClass("active");
  });

  $(".mobile-menu-close-window-btn").click(function (event) {
    event.stopPropagation();
    $(".navbar-btm").removeClass("active");
    $(".ham-menu").removeClass("active");
    $(".navbar-btm .container").removeClass("active");
    $("body").removeClass("active");
  });

  // mobile-dropdown responsive accordion js start--
  $(function () {
    let isMobile = window.matchMedia(
      "only screen and (max-width: 992px)"
    ).matches;

    if (isMobile) {
      // **..mobile-dropdown-accordion js start..**
      $(".megamenu-wrapper").slideUp();
      $(".nav-link-text").on("click", function () {
        $(this).next(".megamenu-wrapper").slideToggle();
        // $(this).parent().toggleClass("active");
        $(this).parent().siblings().find(".megamenu-wrapper").slideUp();
      });
      // **..mobile-dropdown-accordion js end..**
    }

    // mobile-dropdown responsive accordion js start--
    $(function () {
      let isMobile = window.matchMedia(
        "only screen and (max-width: 992px)"
      ).matches;

      if (isMobile) {
        $(".dropdown-menu").slideUp();
        $(".dropdown-menu2").slideUp();
        // **..mobile-dropdown-accordion js start..**
        $(".nav-link-text").on("click", function () {
          $(this).next(".dropdown-menu").slideToggle();
          $(this).toggleClass("active");
        });
        // **..mobile-dropdown-accordion js end..**

        // **..mobile-dropdown-accordion js start..**
        $(".dropdown-link-text").on("click", function () {
          $(this).next(".dropdown-menu2").slideToggle();
          $(this).toggleClass("active");
        });
        // **..mobile-dropdown-accordion js end..**
      }
    });
    // mobile-dropdown responsive accordion js end--
  });
  // mobile-dropdown responsive accordion js end--

  $(".search-bar-open-btn").click(function (event) {
    event.stopPropagation();
    $(".navbar-search-wrap").addClass("active");
    $(".search-bar-close-window-btn").addClass("active");
    $("body").addClass("active");
  });

  $(".search-bar-close-window-btn").click(function (event) {
    event.stopPropagation();
    $(".navbar-search-wrap").removeClass("active");
    $(this).removeClass("active");
    $("body").removeClass("active");
  });

  $(".search-close-btn").click(function (event) {
    event.stopPropagation();
    $(".navbar-search-wrap").removeClass("active");
    $(".search-bar-close-window-btn").removeClass("active");
    $("body").removeClass("active");
  });

  // -- megamenu-tab js start--
  $(".tabs-nav-item-link").click(function () {
    $(".tab-nav-item").removeClass("active");
    $(this).parent().addClass("active");
    $(".tab-content-item").hide();

    var activeTab = $(this).attr("href");
    $(activeTab).fadeIn();
    return false;
  });
  // --megamenu-tab js end--

  // navbar js end ---

  // collection-grid js start---
  $(".grid2-btn").click(function (event) {
    event.stopPropagation();
    $(".collection-items").addClass("grid2");
    $(".collection-items").removeClass("grid3");
    $(".collection-items").removeClass("grid4");
  });

  $(".grid3-btn").click(function (event) {
    event.stopPropagation();
    $(".collection-items").addClass("grid3");
    $(".collection-items").removeClass("grid2");
    $(".collection-items").removeClass("grid4");
  });

    $(".grid4-btn").click(function (event) {
    event.stopPropagation();
    $(".collection-items").addClass("grid4");
    $(".collection-items").removeClass("grid2");
    $(".collection-items").removeClass("grid3");
  });
  // collection-grid js end---

  // collection filter sidebar js start--
  $(".filter-open-btn").click(function (event) {
    event.stopPropagation();
    $(".collection-filter").addClass("active");
    $("body").addClass("active");
  });

  $(".filter-window-close-btn").click(function (event) {
    event.stopPropagation();
    $(".collection-filter").removeClass("active");
    $("body").removeClass("active");
  });

  $(".filter-close-btn").click(function (event) {
    event.stopPropagation();
    $(".collection-filter").removeClass("active");
    $("body").removeClass("active");
  });
  // collection filter sidebar js end--

  // **..collection filter-accordion js start..**
  $(".accordion-toggle-btn").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
  });
  // **..collection filter-accordion js end..**

  // **..product-accordion js start..**
  $(".product-accordion-toggle-btn").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
    $(this)
      .parent()
      .siblings()
      .removeClass("active")
      .find(".product-accordion-item-content")
      .slideUp();
  });
  // **..product-accordion js end..**
});

// btn js ---
// primary btn---
$(function () {
  $(".primary-btn")
    .on("mouseenter", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    })
    .on("mouseout", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    });
});

// secondary btn--
$(function () {
  $(".secondary-btn")
    .on("mouseenter", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    })
    .on("mouseout", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    });
});
// btn js ---

// topbar slider js start--
var swiper = new Swiper(".top-bar-slider", {
  slidesPerView: 1,
  loop: true,
  speed: 5000,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
});
// topbar slider js end--

// card-slider js start--
var swiper = new Swiper(".card-slider", {
  slidesPerView: 4,
  spaceBetween: 20,
  grabCursor: true,
  loop: false,
  navigation: {
    nextEl: ".card-slider-button-next",
    prevEl: ".card-slider-button-prev",
  },
  breakpoints: {
    // when window width is >= 1px
    1: {
      spaceBetween: 10,
      slidesPerView: 2.2,
    },
    // when window width is >= 430px
    576: {
      spaceBetween: 20,
      slidesPerView: 2.3,
    },
    // when window width is >= 767px
    768: {
      spaceBetween: 20,
      slidesPerView: 3.2,
    },
    // when window width is >= 767px
    993: {
      spaceBetween: 20,
      slidesPerView: 4,
    },
  },
});
// card-slider js end--

// gallery-slider js start--
var swiper = new Swiper(".gallery-slider", {
  slidesPerView: "auto",
  spaceBetween: 20,
  centeredSlides: true,
  preventClicks: true,
  maxBackfaceHiddenSlides: 0,
  loop: true,
  navigation: {
    nextEl: ".gallery-slider-button-next",
    prevEl: ".gallery-slider-button-prev",
  },
  on: {
    init: function () {
      $(".gallery-slider .swiper-slide").addClass("changed");
    },
    slideChangeTransitionStart: function () {
      $(".gallery-slider .swiper-slide").addClass("changing");
      $(".gallery-slider .swiper-slide").removeClass("changed");
    },
    slideChangeTransitionEnd: function () {
      $(".gallery-slider .swiper-slide").removeClass("changing");
      $(".gallery-slider .swiper-slide").addClass("changed");
    },
  },
  breakpoints: {
    // when window width is >= 1px
    1: {
      spaceBetween: 10,
    },
    // when window width is >= 430px
    576: {
      spaceBetween: 20,
    },
  },
});
// gallery-slider js end--

// related-product-slider js start--
var swiper = new Swiper(".related-product-slider", {
  slidesPerView: 4,
  spaceBetween: 20,
  grabCursor: true,
  loop: false,
  navigation: {
    nextEl: ".related-product-slider-btn-next",
    prevEl: ".related-product-slider-btn-prev",
  },
  breakpoints: {
    // when window width is >= 1px
    1: {
      spaceBetween: 10,
      slidesPerView: 1.7,
    },
    // when window width is >= 430px
    576: {
      spaceBetween: 20,
      slidesPerView: 2.3,
    },
    // when window width is >= 767px
    768: {
      spaceBetween: 20,
      slidesPerView: 3.2,
    },
    // when window width is >= 767px
    993: {
      spaceBetween: 20,
      slidesPerView: 4,
    },
  },
});

// category slider js start--
var swiper = new Swiper(".category-slider", {
  slidesPerView: 4,
  spaceBetween: 20,
  grabCursor: true,
  loop: false,
  // navigation: {
  //   nextEl: ".related-product-slider-btn-next",
  //   prevEl: ".related-product-slider-btn-prev",
  // },
  breakpoints: {
    // when window width is >= 1px
    1: {
      spaceBetween: 10,
      slidesPerView: 2,
      loop: true,
    },
    // when window width is >= 430px
    576: {
      spaceBetween: 10,
      slidesPerView: 2,
      loop: true,
    },
    // when window width is >= 767px
    768: {
      spaceBetween: 10,
      slidesPerView: 2,
       loop: true,
    },
    // when window width is >= 767px
    993: {
      spaceBetween: 20,
      slidesPerView: 4,
       loop: false,
    },
  },
});
// category slider js end--

// product-slider js start---
var swiper = new Swiper(".product-slider-thumb", {
  loop: false,
  spaceBetween: 30,
  slidesPerView: 4,
  freeMode: true,
  mousewheel: true,
  breakpoints: {
    // when window width is >= 320px
    1: {
      spaceBetween: 10,
      slidesPerView: 3,
    },
    // when window width is >= 576px
    576: {
      spaceBetween: 30,
      slidesPerView: 4,
    },
    // when window width is >= 767px
    768: {
      spaceBetween: 30,
      slidesPerView: 4,
    },
  },
});
var swiper2 = new Swiper(".product-slider", {
  loop: true,
  autoHeight: true,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiper,
  },
});
// product-slider js end---


// related-wishlist-slider js start--
var swiper = new Swiper(".related-wishlist-slider", {
  slidesPerView: 4,
  spaceBetween: 20,
  grabCursor: true,
  loop: true,
  navigation: {
    nextEl: ".wishlist-slider-button-next",
    prevEl: ".wishlist-slider-button-prev",
  },
  breakpoints: {
    // when window width is >= 1px
    1: {
      spaceBetween: 10,
      slidesPerView: 1.7,
    },
    // when window width is >= 430px
    576: {
      spaceBetween: 20,
      slidesPerView: 2.3,
    },
    // when window width is >= 767px
    768: {
      spaceBetween: 20,
      slidesPerView: 3.2,
    },
    // when window width is >= 767px
    993: {
      spaceBetween: 20,
      slidesPerView: 4,
    },
  },
});
// related-wishlist-slider js end--


  // Change image when product option changes
  $(document).ready(function(){
    $(".option_input").on("change", function () {
      let optionName = "";
      let optText = $(this).val();
      $(this).closest('.product-varient').find('.selected_option').text(optText);

      // Get selected option value
      $("input:radio.option_input:checked").each(function (e) {
        optionName += e !== 0 ? "-" : "";
        optionName += $(this).val();
      });

      $("#productSelect option").each(function () {
        var txt = $.trim($(this).text());
        if (txt === optionName) {
          var img = $(this).data("img");
          var id = $(this).val();
          var price = $(this).data("price");
          var compare_price = $(this).data("compare");
          var available = $(this).data("available");
          $("#productSelect").val(id);
          $("#product_id").val(id);

          if (available) {
            $(".addToCart").removeClass("sold_out").html("ADD TO CART <span></span>");
          } else {
            $(".addToCart").addClass("sold_out").html("SOldout <span></span>");
          }

          // $(".thumb_image img").each(function (index) {
          //   var src = $(this).attr("src").split("?")[0]; // Remove query parameters
          //   var cleanImg = img.split("?")[0];
          //   if (src === cleanImg) {
          //     swiper2.slideToLoop(index, 500, false);
          //     $(".thumb_image").removeClass("active"); // Remove active class from all
          //     $(this).closest(".thumb_image").addClass("active"); // Add to selected
          //   }
          // });
        }
      });
    });
  })
  
